import { DEFAULT_CONESTOGA_POLICIES } from '../data/defaultConestogaPolicies';
import gradingPolicyService from './gradingPolicyService';

export async function ensureDefaultConestogaPoliciesLoaded() {
  try {
    const existing = gradingPolicyService.getStoredPolicies();

    const updated = existing.map((policy) => {
      const matchingDefault = DEFAULT_CONESTOGA_POLICIES.find(
        (defaultPolicy) => defaultPolicy.id === policy.id
      );

      if (!matchingDefault) return policy;

      if (
        policy.name === matchingDefault.name &&
        policy.description === matchingDefault.description
      ) {
        return policy;
      }

      return {
        ...policy,
        name: matchingDefault.name,
        description: matchingDefault.description
      };
    });

    const missing = DEFAULT_CONESTOGA_POLICIES.filter(
      (policy) => !updated.some((p) => p.id === policy.id)
    );

    const nextPolicies = [...updated, ...missing];
    const hasChanges =
      nextPolicies.length !== existing.length ||
      nextPolicies.some((policy, index) => {
        const original = existing[index];
        if (!original) return true;
        return policy.name !== original.name || policy.description !== original.description;
      });

    if (hasChanges) {
      gradingPolicyService.savePolicies(nextPolicies);
      return gradingPolicyService.getStoredPolicies();
    }

    return existing;
  } catch (error) {
    console.error('Failed to bootstrap Conestoga grading policies', error);
    return [];
  }
}
